import { render, staticRenderFns } from "./WorkHome.vue?vue&type=template&id=ff9dd2ae&"
import script from "./WorkHome.vue?vue&type=script&lang=js&"
export * from "./WorkHome.vue?vue&type=script&lang=js&"
import style0 from "./WorkHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports